import React from 'react';
import cl from 'classnames';

import { IconsEnum } from '../../assets/icons/types';
import { Icon } from '../Icon';
import { PureIconButtonHelper } from '../buttons/PureIconButtonHelper';

interface CommandHeaderProps {
  title: string;
  alias: string;
  onClear: () => void;
  className?: string;
}

function CommandHeader({
  title,
  alias,
  onClear,
  className
}: CommandHeaderProps) {
  return (
    <div
      className={cl(
        'col-span-full py-1 px-2 dark text-white flex gap-2 rounded-t-md bg-purple-600/60 dark:bg-purple-600/60',
        className
      )}
    >
      <Icon icon={IconsEnum.COMMAND_OUTLINE} className="h-4 w-4" />
      <span className="leading-4 text-xs">{title}</span>
      <span className="bg-purple-800/30 dark:bg-purple-950/50 rounded text-2xs leading-4 px-1">
        /{alias}
      </span>
      <PureIconButtonHelper
        icon={IconsEnum.X_CIRCLE}
        iconClassName="h-4 w-4"
        className="p-0 rounded-full inline-flex items-center leading-5 focus:ring-base text-white/50 dark:text-white/50 hover:text-gray-800 dark:hover:text-gray-100 focus:ring-offset-0 transition-colors duration-150 ease-out"
        onClick={onClear}
      />
    </div>
  );
}

export default CommandHeader;
